module.exports = __webpack_public_path__ + "img/IMG_1156_L_Wood_MockedUp.2755b0a3.jpg";